<template>
	<div class="login-page">
		<!-- <video :src="backgroundVideo" autoplay loop muted :poster="backgroundImage">您的浏览器不支持HTML5视频标签。</video> -->
		<img class="bg" src="@/assets/bg.png" alt="" />
		<!-- <router-link tag="div" class="logo" :to="{ name: 'home' }">
			<svg-icon name="logo" />
		</router-link> -->
		<router-link tag="div" class="home-btn" :to="{ path: '/index', hash: 'top' }">
			<el-button type="primary" @click.prevent="toHome()">进入首页</el-button>
		</router-link>
		<div class="body">
			<div class="body-left">
				<div class="heading-1">中国集装箱行业</div>
				<div class="heading-2">绿色低碳公共服务平台</div>
				<!-- <div class="des">探索碳足迹管理提供了基础数据支撑，加快推动碳足迹管理体系建设探索碳足迹管理提供了基础数据支撑，加快推动碳足迹管理体系建设</div> -->
			</div>
			<div class="body-right">
				<!-- 验证码登录 -->
				<el-form key="codeLoginForm" :model="codeLoginForm" :rules="codeLoginRule" ref="codeLoginForm"
					class="card code-login" v-if="loginType == '2'">
					<div class="tabs">
						<div class="tabs-item active">验证码登录</div>
						<div class="tabs-item" @click="changeLoginType('1')">密码登录</div>
					</div>
					<el-form-item prop="mobile">
						<div class="phone-box">
							<el-input type="number" v-maxlength="11" clearable v-model.trim="codeLoginForm.mobile"
								placeholder="请输入手机号"></el-input>
							<div class="prefix">+86</div>
						</div>
					</el-form-item>
					<el-form-item prop="confirmSuccess">
						<div class="slide" @mousedown.capture="checkCanSliderCode">
							<SliderCode :key="sliderKey" ref="SliderCode" @confirmSuccessBool="confirmSuccessFn"></SliderCode>
						</div>
					</el-form-item>
					<el-form-item prop="verificationCode">
						<div class="code-box">
							<el-input type="number" v-maxlength="6" clearable v-model.trim="codeLoginForm.verificationCode"
								placeholder="请输入验证码"></el-input>
							<div class="suffix" @click="sendCode">
								<CountDown ref="CountDown" :seconds="60" class="yanzhengma-btn"></CountDown>
							</div>
						</div>
					</el-form-item>
					<!-- 验证码登录按钮添加loading -->
					<el-button class="login-btn" type="primary" @click="loginByCode" :loading="loginLoading">
						<span v-if="!loginLoading">登录</span>
						<span v-else>登录中...</span>
					</el-button>
					<el-form-item prop="isAgree">
						<div class="agreement-box">
							<div class="checkbox-wrapper">
								<el-checkbox v-model="codeLoginForm.isAgree"></el-checkbox>
							</div>
							<div class="content">
								未注册手机登录时会自动创建新账号，我已阅读并同意
								<br />
								<el-button type="text" @click="openPopAgreement('userAgreement')">用户协议</el-button>
								和
								<el-button type="text" @click="openPopAgreement('privacyAgreement')">隐私权政策</el-button>
							</div>
						</div>
					</el-form-item>
				</el-form>
				<!-- 密码登录 -->
				<el-form autocomplete="off" key="passwordLoginForm" :model="passwordLoginForm"
					:rules="passwordLoginRule" ref="passwordLoginForm" class="card password-login"
					v-else-if="loginType == '1'">
					<div class="tabs">
						<div class="tabs-item" @click="changeLoginType('2')">验证码登录</div>
						<div class="tabs-item active">密码登录</div>
					</div>
					<el-form-item prop="username">
						<div class="phone-box">
							<el-input
								@keyup.native="passwordLoginForm.username = passwordLoginForm.username.replace(/[\u4E00-\u9FA5]/g, '').trim()"
								clearable v-model.trim="passwordLoginForm.username" placeholder="请输入手机号或账号"></el-input>
						</div>
					</el-form-item>
					<el-form-item prop="password">
						<div class="password-box">
							<el-input autocomplete="new-password" show-password clearable
								v-model.trim="passwordLoginForm.password" placeholder="请输入密码"></el-input>
						</div>
					</el-form-item>
					<!-- 密码登录按钮添加loading -->
					<el-button class="login-btn" type="primary" @click="loginByPassword" :loading="loginLoading">
						<span v-if="!loginLoading">登录</span>
						<span v-else>登录中...</span>
					</el-button>
					<el-form-item prop="isAgree">
						<div class="agreement-box">
							<div class="checkbox-wrapper">
								<el-checkbox v-model="passwordLoginForm.isAgree"></el-checkbox>
							</div>
							<div class="content">
								未注册手机登录时会自动创建新账号，我已阅读并同意
								<br />
								<el-button type="text" @click="openPopAgreement('userAgreement')">用户协议</el-button>
								和
								<el-button  type="text" @click="openPopAgreement('privacyAgreement')">隐私权政策</el-button>
							</div>
						</div>
					</el-form-item>
					<div class="card-footer">
						<div class="forget" @click="forgetPassword">忘记密码?</div>
						<div class="register">
							没有账户!
							<router-link tag="span" :to="{ name: 'register' }">
								<span class="c-primary c-pointer">立即注册</span>
							</router-link>
						</div>
					</div>
				</el-form>
			</div>
		</div>
		<div class="footer">
			<div class="field">版权所有 {{ webInfo.copyright }}</div>
			<div class="field">联系方式：{{ webInfo.email }}</div>
		</div>

		<!-- 协议弹窗 -->
		<PopAgreement ref="PopAgreement"></PopAgreement>

		<!-- 拼图验证 -->
		<Vcode :show="isShow" @success="onSuccess" @close="onClose" />
	</div>
</template>

<script>
import { Login, ValidatePhone, NSlider, SmsSend, ConfigValue, ValidatePerson } from '@/common/api.js';
import { userAgreement, privacyAgreement } from '@/common/data.js';
// 协议弹窗
import PopAgreement from '@/components/PopAgreement/PopAgreement.vue';
// 滑块组件
import SliderCode from '@/components/SliderCode/SliderCode.vue';
// 验证码组件
import CountDown from '@/components/CountDown/CountDown.vue';
// 加密插件
import useJsencrypt from '@/common/useJsencrypt.js';
import { webInfo } from '@/common/data.js';
// 拼图验证
import Vcode from 'vue-puzzle-vcode';
export default {
	components: { PopAgreement, SliderCode, CountDown, Vcode },
	data() {
		// 手机号验证
		var validatePhone = (rule, value, callback) => {
			let result = this.verifyVal({ val: value, rules: ['phone'] });
			if (result.valid) {
				callback();
			} else {
				callback(new Error('手机号格式不正确'));
			}
		};
		// 勾选协议验证
		var validateAgree = (rule, value, callback) => {
			if (value === false) {
				callback(new Error('请阅读并勾选协议'));
			} else {
				callback();
			}
		};
		// 滑块验证
		var validateSlider = (rule, value, callback) => {
			if (value === false) {
				callback(new Error('请将滑块拖动至最右'));
			} else {
				callback();
			}
		};
		return {
			webInfo: webInfo,
			// 背景视频
			backgroundVideo: '',
			// 背景图片
			backgroundImage: '',
			// 登录类型
			loginType: '1', // 1 密码登录 2 验证码登录
			// 登录loading状态
			loginLoading: false, // 新增：控制登录按钮loading
			// 密码登录表单
			passwordLoginForm: {
				// 手机号或账户
				username: '',
				// 密码
				password: '',
				// 是否勾选协议
				isAgree: false
			},
			// 密码登录表单验证
			passwordLoginRule: {
				username: [{ required: true, message: '请输入手机号或账号', trigger: 'blur' }],
				password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
				isAgree: [{ validator: validateAgree }]
			},
			// 验证码登录表单
			codeLoginForm: {
				// 手机号
				mobile: '',
				// 验证码
				verificationCode: '',
				// 是否勾选协议
				isAgree: false,
				// 滑块验证
				confirmSuccess: false,
				// 滑块验证hash
				code: ''
			},
			// 验证码登录表单验证
			codeLoginRule: {
				mobile: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
					{ validator: validatePhone },
				],
				verificationCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
				isAgree: [{ validator: validateAgree }],
				confirmSuccess: [{ validator: validateSlider }]
			},
			// 是否显示拼图验证
			isShow: false,
			// 短信发送中，防止连点
			smsSending: false,
			sliderKey: 0
		};
	},
	created() {
		this.getConfigValue();
	},
	methods: {
		toHome(e) {
			this.$store.dispatch('delView', 'home').then(() => {
				this.$store.dispatch('addView', 'home')
				this.$router.push({ path: '/index', hash: 'top' })
			})
		},
		// 检查是否可以拖动滑块
		checkCanSliderCode() {
			this.$refs.codeLoginForm.validateField('mobile', (errorMessage) => {
				if (errorMessage) {
					this.$refs.SliderCode.sliderCodeable = false
				} else {
					this.$refs.SliderCode.sliderCodeable = true
				}
			});
		},
		// 忘记密码
		forgetPassword() {
			// this.toast({
			// 	type: 'warning',
			// 	message: '功能暂未开放'
			// })
			this.$router.push({ name: 'forget' });
		},
		// 清空滑块 UI + 票据（发送成功/失效后必须重新拖）
		resetSlider() {
			this.codeLoginForm.confirmSuccess = false;
			this.codeLoginForm.code = '';
			this.sliderKey += 1;
		},
		// 发送验证码（滑块票据后端仅 60s，拖完后应尽快发送）
		sendCode() {
			if (this.smsSending) {
				return;
			}
			this.$refs.codeLoginForm.validateField('mobile', (errorMessage) => {
				if (!errorMessage) {
					this.$refs.codeLoginForm.validateField('confirmSuccess', (confirmSuccess_errorMessage) => {
						if (!confirmSuccess_errorMessage) {
							if (this.$refs.CountDown.canGetCode) {
								if (!this.codeLoginForm.code) {
									this.$message.warning('请先完成滑块验证');
									this.resetSlider();
									return;
								}
								let data = {
									smsType: 'slider',
									code: useJsencrypt(this.codeLoginForm.code)
								};
								this.smsSending = true;
								SmsSend(data)
									.then((res) => {
										if (res.success) {
											if (res.code === '163') {
												this.onShow();
											} else {
												this.$refs.CountDown.start();
												// 后端已消费票据，界面必须清掉「验证通过」
												this.resetSlider();
											}
										} else {
											this.$message.error(res.message || '发送失败');
											if ((res.message || '').indexOf('已失效') !== -1) {
												this.$message.warning('滑块已过期，请重新拖动后再获取验证码');
											}
											this.resetSlider();
										}
									})
									.finally(() => {
										this.smsSending = false;
									});
							}
						}
					});
				}
			});
		},
		// 打开拼图验证
		onShow() {
			this.isShow = true;
		},
		// 关闭拼图验证
		onClose() {
			this.isShow = false;
		},
		// 拼图验证成功
		onSuccess() {
			let data = {
				mobile: this.codeLoginForm.mobile
			};
			ValidatePerson(data).then((res) => {
				if (res.success) {
					this.onClose();
					this.sendCode();
				}
			});
		},
		// 验证码登录
		loginByCode() {
			this.$refs.codeLoginForm.validate((valid) => {
				if (valid) {
					// 开始loading
					this.loginLoading = true;
					let data = {
						mobile: this.codeLoginForm.mobile,
						verificationCode: this.codeLoginForm.verificationCode
					};
					ValidatePhone(data).then((res) => {
						// 结束loading
						this.loginLoading = false;
						if (res.success) {
							if (res.data == 'true') {
								// true-账号不存在-走注册, false-账号存在-走登陆
								let obj = {
									mobile: this.codeLoginForm.mobile,
									verificationCode: this.codeLoginForm.verificationCode
								};
								this.$store.commit('changeRegInfo', obj);
								this.$router.push({ name: 'registerApply' });
							} else {
								this.login();
							}
						} else {
							this.$message.error(res.message);
						}
					}).catch((error) => {
						// 异常情况也需要结束loading
						this.loginLoading = false;
						console.error('验证手机号失败:', error);
						this.$message.error('网络异常，请稍后重试');
					});
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 改变登录类型
		changeLoginType(type) {
			this.loginType = type;
		},
		// 打开协议弹窗
		openPopAgreement(type) {
			let data = {
				title: '',
				content: ''
			};
			if (type == 'userAgreement') {
				(data.title = userAgreement.title), (data.content = userAgreement.content);
			} else if (type == 'privacyAgreement') {
				(data.title = privacyAgreement.title), (data.content = privacyAgreement.content);
			}
			this.$refs.PopAgreement.open({
				...data
			});
		},
		// 密码登录
		loginByPassword() {
			this.$refs.passwordLoginForm.validate((valid) => {
				if (valid) {
					// 开始loading
					this.loginLoading = true;
					this.login();
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 登录
		login() {
			let data = {};
			if (this.loginType == '1') {
				data = {
					username: this.passwordLoginForm.username,
					password: useJsencrypt(this.passwordLoginForm.password),
					vCode: '',
					mobile: '',
					systemType: 'CARBON_DATA',
					verificationCode: '',
					isLongTimeToken: false,
					loginType: this.loginType
				};
			}
			if (this.loginType == '2') {
				data = {
					username: this.codeLoginForm.mobile,
					password: '',
					vCode: '',
					mobile: this.codeLoginForm.mobile,
					systemType: 'CARBON_DATA',
					verificationCode: this.codeLoginForm.verificationCode,
					isLongTimeToken: false,
					loginType: this.loginType
				};
			}

			Login(data).then((res) => {
				// 结束loading
				this.loginLoading = false;
				if (res.success) {
					this.$store.commit('changeToken', res.data.accesstoken);
					this.$router.push({ name: 'home' });
				} else {
					this.toast(res.message, 'error');
				}
			}).catch((error) => {
				// 异常情况也需要结束loading
				this.loginLoading = false;
				console.error('登录失败:', error);
				this.$message.error('网络异常，请稍后重试');
			});
		},
		// 获取背景视频、图片
		getConfigValue() {
			ConfigValue({
				configKey: 'login.background.video'
			}).then((res) => {
				this.backgroundVideo = res.data;
			});
			ConfigValue({
				configKey: 'login.background.image'
			}).then((res) => {
				this.backgroundImage = res.data;
			});
		},
		// 滑块操作成功：拿到票据后立即发短信，避免超过后端 60s 有效期
		confirmSuccessFn(val) {
			this.codeLoginForm.confirmSuccess = val;
			if (!val) {
				return;
			}
			let data = {
				mobile: this.codeLoginForm.mobile
			};
			NSlider(data).then((res) => {
				if (res.success || res.code === '200') {
					this.codeLoginForm.code = res.data;
					this.sendCode();
				} else {
					this.$message.error(res.message || '滑块验证失败');
					this.resetSlider();
				}
			}).catch(() => {
				this.resetSlider();
			});
		}
	}
};
</script>

<style lang="scss" scoped>
@function vw($px) {
	@return $px / 1440 * 100vw;
}

@function vh($px) {
	@return $px / 735 * 100vh;
}

.login-page {
	// flex: 1;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	// background-image: url('~@/assets/tmp/017.png');
	background-size: cover;
	position: relative;

	video {
		z-index: -1;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 100%;
		// width: 100vw;
		// height: 100vh;
		object-fit: cover;
	}
	
	.bg {
		z-index: -1;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 100%;
		// width: 100vw;
		// height: 100vh;
		object-fit: cover;
	}

	.svg-logo {
		position: absolute;
		top: 0;
		left: 0;
		margin-top: vh(10);
		margin-left: vw(40);
		width: 328px;
		height: 41px;
	}

	.home-btn {
		position: absolute;
		top: 0;
		right: 0;
		display: flex;

		.el-button {
			margin-top: 10px;
			margin-right: 40px;
			align-self: center;
			margin-left: 10px;
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 0;
			width: 114px;
			height: 40px;
			border-radius: 4px;
			// font-weight: bold;
			font-size: 14px;
			line-height: 20px;
		}
	}

	.body {
		flex: 1;
		display: flex;
		justify-content: space-between;

		.body-left {
			margin-left: vw(94);
			flex: 1;
			padding-right: vw(20);
			align-self: center;
			transform: translateY(-160px);

			.heading-1 {
				// margin-top: vh(216);
				font-family: FZLTCHJW--GB1, FZLTCHJW--GB1;
				font-weight: bold;
				font-size: 40px;
				color: #FFFFFF;
				line-height: 51px;
				letter-spacing: 3px;
			}

			.heading-2 {
				margin-top: 10px;
				font-family: FZLTCHJW--GB1, FZLTCHJW--GB1;
				font-weight: bold;
				font-size: 40px;
				color: #FFFFFF;
				line-height: 51px;
				letter-spacing: 3px;
			}

			.des {
				width: 465px;
				margin-top: 73px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 14px;
				color: #FFFFFF;
				line-height: 21px;
			}
		}

		.body-right {
			margin-right: vw(90);
			align-self: center;

			.code-login {
				width: 390px;
				height: 460px;
				background: #ffffff;
				box-sizing: border-box;
				padding: 0 28px;
				display: flex;
				flex-direction: column;

				.tabs {
					padding-top: 35px;
					display: flex;

					.tabs-item {
						margin-right: 44px;
						font-size: 16px;
						color: #9e9e9e;
						line-height: 22px;
						cursor: pointer;

						&.active {
							font-weight: bold;
							color: #000000;
						}
					}
				}

				.phone-box {
					margin-top: 28px;
					position: relative;
					display: flex;
					align-items: center;

					::v-deep {
						.el-input {
							.el-input__inner {
								height: 46px;
								padding-left: 73px;
								background: rgba(#ffffff, 1);
								border-radius: 0;
								font-size: 14px;

								&::placeholder {
									color: #9e9e9e;
								}
							}

							.el-input__icon {
								line-height: 46px;
							}
						}
					}

					.prefix {
						left: 15px;
						position: absolute;
						font-size: 14px;
						color: #000000;
						line-height: 20px;
					}
				}

				.slide {
					margin-top: 20px;
					height: 34px;
					background: #ffffff;
					border: 1px solid #e9e9e9;
				}

				.code-box {
					margin-top: 20px;
					position: relative;
					display: flex;

					::v-deep {
						.el-input {
							.el-input__inner {
								height: 46px;
								padding-left: 13px;
								padding-right: 113px;
								background: rgba(#ffffff, 1);
								border-radius: 0;
								font-size: 14px;

								&::placeholder {
									color: #9e9e9e;
								}
							}

							.el-input__suffix {
								right: 113px;
							}

							.el-input__icon {
								line-height: 46px;
							}
						}
					}

					.suffix {
						position: absolute;
						right: 0;
						width: 100px;
						font-size: 14px;
						color: $primary;
						text-align: right;
						box-sizing: border-box;
						padding-right: 13px;
						line-height: 46px;
					}
				}

				.login-btn {
					margin-top: 38px;
					display: flex;
					justify-content: center;
					align-items: center;
					padding: 0;
					border-radius: 0;
					height: 46px;
					line-height: 46px;
					font-weight: bold;
					font-size: 16px;
				}

				.agreement-box {
					display: flex;
					align-items: flex-start;
					margin-top: 50px;

					.checkbox-wrapper {
						margin-right: 2px;
						line-height: 17px;
					}

					.content {
						font-size: 12px;
						color: #000000;
						line-height: 17px;
						white-space: pre-wrap;

						.el-button {
							font-size: 12px;
							line-height: 17px;
							padding: 0;
							margin: 0;
						}
					}
				}
			}

			// 密码登录
			.password-login {
				width: 390px;
				height: 460px;
				background: #ffffff;
				box-sizing: border-box;
				padding: 0 28px;
				display: flex;
				flex-direction: column;
				position: relative;

				.tabs {
					padding-top: 35px;
					display: flex;

					.tabs-item {
						margin-right: 44px;
						font-size: 16px;
						color: #9e9e9e;
						line-height: 22px;
						cursor: pointer;

						&.active {
							font-weight: bold;
							color: #000000;
						}
					}
				}

				.phone-box {
					margin-top: 28px;
					position: relative;
					display: flex;
					align-items: center;

					::v-deep {
						.el-input {
							.el-input__inner {
								height: 46px;
								padding-left: 12px;
								padding-right: 12px;
								// background: rgba(#ffffff, 1);
								border-radius: 0;
								font-size: 14px;

								&::placeholder {
									color: #9e9e9e;
								}
							}
						}
					}
				}

				.password-box {
					margin-top: 20px;
					position: relative;
					display: flex;

					::v-deep {
						.el-input {
							.el-input__inner {
								height: 46px;
								padding-left: 12px;
								padding-right: 12px;
								// background: rgba(#ffffff, 1);
								border-radius: 0;
								font-size: 14px;

								&::placeholder {
									color: #9e9e9e;
								}
							}
						}
					}

					// .suffix {
					// 	position: absolute;
					// 	right: 0;
					// 	width: 100px;
					// 	font-size: 14px;
					// 	color: $primary;
					// 	text-align: right;
					// 	box-sizing: border-box;
					// 	padding-right: 13px;
					// }
				}

				.login-btn {
					margin-top: 32px;
					display: flex;
					justify-content: center;
					align-items: center;
					padding: 0;
					border-radius: 0;
					height: 46px;
					line-height: 46px;
					font-weight: bold;
					font-size: 16px;
				}

				.agreement-box {
					display: flex;
					align-items: flex-start;
					margin-top: 70px;

					.checkbox-wrapper {
						margin-right: 2px;
						line-height: 17px;
					}

					.content {
						font-size: 12px;
						color: #000000;
						line-height: 17px;
						white-space: pre-wrap;

						.el-button {
							font-size: 12px;
							line-height: 17px;
							padding: 0;
							margin: 0;
						}
					}
				}

				.card-footer {
					height: 56px;
					background: #f8f9fc;
					display: flex;
					position: absolute;
					bottom: 0;
					align-items: center;
					padding: 0 28px;
					justify-content: space-between;
					width: 100%;
					left: 0;
					box-sizing: border-box;

					.forget {
						cursor: pointer;
						font-size: 12px;
						color: #9e9e9e;
					}

					.register {
						font-size: 12px;
						color: #9e9e9e;
					}
				}
			}

			// 注册
			.register-card {
				width: 390px;
				height: 460px;
				background: #ffffff;
				box-sizing: border-box;
				padding: 0 28px;
				display: flex;
				flex-direction: column;
				position: relative;

				.heading {
					margin-top: 25px;
					font-weight: bold;
					font-size: 16px;
					color: #000000;
					line-height: 22px;
					text-align: center;
				}

				.svg-logo2 {
					margin-top: 20px;
					width: 307px;
					height: 39px;
					align-self: center;
				}

				.phone-box {
					margin-top: 20px;
					position: relative;
					display: flex;
					align-items: center;

					::v-deep {
						.el-input {
							.el-input__inner {
								height: 46px;
								padding-left: 73px;
								background: rgba(#ffffff, 1);
								border-radius: 0;
								font-size: 14px;

								&::placeholder {
									color: #9e9e9e;
								}
							}
						}
					}

					.prefix {
						left: 15px;
						position: absolute;
						font-size: 14px;
						color: #000000;
						line-height: 20px;
					}
				}

				.slide {
					margin-top: 20px;
					height: 34px;
					background: #ffffff;
					border: 1px solid #e9e9e9;
				}

				.code-box {
					margin-top: 20px;
					position: relative;
					display: flex;

					::v-deep {
						.el-input {
							.el-input__inner {
								height: 46px;
								padding-left: 13px;
								padding-right: 113px;
								background: rgba(#ffffff, 1);
								border-radius: 0;
								font-size: 14px;

								&::placeholder {
									color: #9e9e9e;
								}
							}
						}
					}

					.suffix {
						position: absolute;
						right: 0;
						width: 100px;
						font-size: 14px;
						color: $primary;
						text-align: right;
						box-sizing: border-box;
						padding-right: 13px;
					}
				}

				.login-btn {
					margin-top: 38px;
					display: flex;
					justify-content: center;
					align-items: center;
					padding: 0;
					border-radius: 0;
					height: 46px;
					line-height: 46px;
					font-weight: bold;
					font-size: 16px;
				}

				.card-footer {
					height: 56px;
					background: #f8f9fc;
					display: flex;
					position: absolute;
					bottom: 0;
					align-items: center;
					padding: 0 28px;
					justify-content: center;
					width: 100%;
					left: 0;
					box-sizing: border-box;

					.register {
						font-size: 12px;
						color: #9e9e9e;
						display: flex;
						align-items: center;

						img {
							width: 6px;
							height: 8px;
							margin-left: 5px;
						}
					}
				}
			}
		}
	}

	.footer {
		display: flex;
		justify-content: center;
		position: absolute;
		left: 0;
		right: 0;
		bottom: vh(27);

		.field {
			font-size: 12px;
			color: #ffffff;
			line-height: 27px;
			text-align: center;
			margin: 0 5px;
		}
	}
}


/* 输入框统一提升高度、拉开间距 */
.login-form-item {
    margin-bottom: 18px !important; /* 原本挤在一起，现在正常间距 */
}

.login-form-item input,
.login-form-item .el-input__inner {
    height: 42px !important;   /* 稍微调高，看起来更高级 */
    border-radius: 8px !important;
}

/* 登录面板稍微放大 + 调整比例 */
.login-box {
    width: 360px !important;      /* 不改变布局，只轻微调宽度 */
    padding: 32px 28px !important;
    border-radius: 14px !important;
    background: rgba(255,255,255,0.10) !important;
    backdrop-filter: blur(14px) !important;
}

/* 按钮提升质感 */
.login-btn {
    height: 44px !important;
    border-radius: 10px !important;
}

/* 输入框聚焦更高级，但不改变颜色 */
.login-form-item input:focus,
.login-form-item .el-input__inner:focus {
    box-shadow: 0 0 0 3px rgba(255,255,255,0.15);
}

</style>